import React from "react";

const Biomatrix = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            fill={fill}
            d="M26.042 19.369v1.579c0 4.373-1.044 8.597-3.012 12.388l-.356.664-2.748-1.538a23.62 23.62 0 0 0 2.96-10.794l.01-.72v-1.58h3.146Zm-9.436-4.737h3.145v6.316l-.009.598a20.483 20.483 0 0 1-4.232 11.92l-.363.46-2.436-1.999a17.32 17.32 0 0 0 3.885-10.4l.01-.58v-6.315Zm1.572-6.316c4.343 0 7.864 3.535 7.864 7.895h-3.145c0-2.616-2.113-4.737-4.719-4.737-2.606 0-4.718 2.12-4.718 4.737v4.737c0 3.53-1.29 6.86-3.572 9.437l-.333.363-2.277-2.178a11.026 11.026 0 0 0 3.026-7.144l.01-.478V16.21c0-4.36 3.521-7.895 7.864-7.895Zm0-6.316c7.818 0 14.155 6.362 14.155 14.21v4.738c0 2.68-.317 5.32-.938 7.88l-.219.85-3.035-.83a30.1 30.1 0 0 0 1.034-7.003l.013-.897V16.21c0-6.104-4.93-11.053-11.01-11.053-2.473 0-4.755.819-6.593 2.2L9.344 5.107A14.06 14.06 0 0 1 18.178 2ZM7.118 7.341l2.243 2.25a11.026 11.026 0 0 0-2.186 6.24l-.007.378.006 3.16c0 1.767-.415 3.478-1.197 5.017l-.245.456L3 23.276a7.86 7.86 0 0 0 1.016-3.446l.013-.461V16.21a14.15 14.15 0 0 1 3.089-8.87Z"
        />
    </svg>
);

export default Biomatrix;